import { WalletProviderE } from '@tacans/shared-marketplace-layer';
import { ISvgIcon } from 'src/ui/common/atoms/svg-icon/svg-icon.types';

export const ICONS: Record<WalletProviderE, ISvgIcon> = {
    [WalletProviderE.Concordium]: {
        icon: 'ccd',
        variant: 'regular'
    },
    [WalletProviderE.Ethereum]: {
        icon: 'ethereum',
        variant: 'light'
    },
};
